import { useState, useEffect } from "react";

const PAYMENT_LINK_EXPIRY_MINUTES = 16; // Razorpay payment link expires in 16 minutes
const PAYMENT_LINK_EXPIRY_SECONDS = PAYMENT_LINK_EXPIRY_MINUTES * 60;

export const usePaymentLinkExpiry = (
  paymentLinkSentTime,
  paymentLinkExpiresAt
) => {
  const [isExpired, setIsExpired] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [formattedTime, setFormattedTime] = useState("");
  const [expiresAt, setExpiresAt] = useState(null);

  useEffect(() => {
    if (!paymentLinkSentTime && !paymentLinkExpiresAt) {
      setIsExpired(false);
      setTimeRemaining(null);
      setFormattedTime("");
      setExpiresAt(null);
      return;
    }

    const checkExpiry = () => {
      const now = new Date();
      const resolvedExpiresAt = paymentLinkExpiresAt
        ? new Date(paymentLinkExpiresAt)
        : new Date(
            new Date(paymentLinkSentTime).getTime() +
              PAYMENT_LINK_EXPIRY_SECONDS * 1000
          );

      const remaining = Math.floor((resolvedExpiresAt - now) / 1000);

      if (remaining <= 0) {
        setIsExpired(true);
        setTimeRemaining(0);
        setFormattedTime("Expired");
        setExpiresAt(resolvedExpiresAt);
      } else {
        setIsExpired(false);
        setTimeRemaining(remaining);
        setExpiresAt(resolvedExpiresAt);

        // Format as "MM:SS"
        const minutes = Math.floor(remaining / 60);
        const seconds = remaining % 60;
        setFormattedTime(
          `${minutes}:${seconds.toString().padStart(2, "0")}`
        );
      }
    };

    // Check immediately
    checkExpiry();

    // Check every second
    const interval = setInterval(checkExpiry, 1000);

    return () => clearInterval(interval);
  }, [paymentLinkSentTime, paymentLinkExpiresAt]);

  return {
    isExpired,
    timeRemaining,
    formattedTime,
    canResend: isExpired,
    expiresAt,
  };
};
